module.exports = __webpack_public_path__ + "img/modulo_Review.03f119c.svg";